import { isVideoArticlePage, isWebView } from '../../utils/aem-utils';

export const videoPlayerModule = {
  name: 'Video Player',
  shouldInit: () => !isWebView() && !isVideoArticlePage(),
};
